<script setup>

    const props = defineProps({
        data: {},
        selected: {
            default: false
        },
        index: {}
    })

</script>

<template>

    <li
        class="flex min-w-0 gap-x-2 items-center px-5 py-4 hover:bg-lifeworx-blue-500 hover:bg-opacity-20 select-none cursor-pointer"
        :class="{
            'bg-lifeworx-blue-400 bg-opacity-20 even:bg-lifeworx-blue-400 even:bg-opacity-20': props.selected == true,
            'even:bg-stone-500 even:bg-opacity-5': props.selected == false
        }"
        :id="'latte-map-view-list-item-' + props.data.id"
    >

        <div
            class="h-8 w-8 rounded-full text-center flex flex-shrink-0 items-center justify-center align-middle text-sm font-bold"
            :class="{
                'bg-lifeworx-purple-500 text-lifeworx-purple-500': props.data.type == 'client',
                'bg-lifeworx-orange-500 text-lifeworx-orange-500': props.data.type == 'prospect',
                'bg-opacity-10': props.selected == false,
                'text-white': props.selected == true,

            }"
        >
            {{ index+1 }}
        </div>

        <div
            class="min-w-0 flex-auto flex items-center"
        >

            <div class="">

                <div
                    class=" uppercase text-3xs tracking-wider font-bold"
                    :class="{
                        'text-lifeworx-purple-500': props.data.type == 'client',
                        'text-lifeworx-orange-500': props.data.type == 'prospect'
                    }"
                >
                    {{  props.data.type }}
                </div>

                <div
                    class="text-sm md:text-xs text-lifeworx-blue-800"
                >
                    <span>
                        {{ props.data.first_name + ' ' + props.data.last_name }}
                    </span>
                    <template v-if="props.data.address.address && props.data.address.address !== ''">
                        <span class="text-stone-400">
                            at
                        </span>
                        <span>
                            {{ props.data.address.address }}
                        </span>
                    </template>
                    <span class="text-stone-400">
                        in
                    </span>
                    <span>
                        {{ props.data.address.city + ', ' + props.data.address.state }}
                    </span>


                </div>

            </div>

        </div>

    </li>

</template>
